import Super from '@simplepractice/ember-messaging-client/adapters/messaging-conversation';

export default Super.extend({});
